/** Shared config for Lumi topic / legal / story pages. Copy lives in i18n `lumi_pages`. */

const LANG_CODE = { uk: 'UA', en: 'EN', de: 'DE', lt: 'EN' };

export function lumiLangCode(language) {
  const lng = String(language || 'en').split('-')[0];
  return LANG_CODE[lng] || 'EN';
}

/** `bez_L_01_night_kitchen_2am` or an `_ALL_` file name. */
export function worldSrc(name, language) {
  const file = String(name).includes('_L_')
    ? name.replace('_L_', `_${lumiLangCode(language)}_`)
    : name;
  return `/assets/lumi/world/${file}.webp`;
}

export const WORLD_CARDS = [
  { image: 'robota_ALL_06_inbox_storm', href: '/burnout' },
  { image: 'robota_ALL_07_after_shift_voice', href: '/burnout' },
  { image: 'bez_ALL_06_autumn_walk', href: null },
  { image: 'bez_ALL_07_pocket_friend', href: '/download' },
  { image: 'poshuk_ALL_06_untangle_thoughts', href: '/thought-diary' },
  { image: 'poshuk_ALL_07_between_sessions', href: '/between-sessions' },
  { image: 'osvita_ALL_06_book_tower', href: null },
  { image: 'osvita_ALL_07_backpack', href: null }
];

export const LUMI_PAGE_SLUGS = [
  'impressum',
  'how-lumi-works',
  'thought-diary',
  'anxiety',
  'burnout',
  'between-sessions',
  'self-check',
  'lumi-stories',
  'download',
  'faq'
];

export const TOPIC_PAGES = {
  impressum: { kind: 'impressum', images: [], related: ['how-lumi-works', 'download', 'faq'], news: [] },
  'how-lumi-works': {
    kind: 'how',
    images: ['poshuk_ALL_06_untangle_thoughts', 'bez_ALL_07_pocket_friend'],
    related: ['thought-diary', 'self-check', 'anxiety', 'download'],
    news: ['32', '17']
  },
  'thought-diary': {
    kind: 'topic',
    images: ['poshuk_ALL_06_untangle_thoughts', 'robota_L_05_diary_commute', 'poshuk_L_04_evening_journal'],
    related: ['how-lumi-works', 'between-sessions', 'self-check', 'anxiety'],
    news: ['32', '17']
  },
  anxiety: {
    kind: 'topic',
    images: ['bez_L_01_night_kitchen_2am', 'bez_L_02_breathe_before_reply', 'poshuk_L_05_night_window'],
    related: ['self-check', 'thought-diary', 'burnout', 'how-lumi-works'],
    news: ['17', '14']
  },
  burnout: {
    kind: 'topic',
    images: ['robota_ALL_06_inbox_storm', 'robota_ALL_07_after_shift_voice', 'robota_L_04_lunch_break'],
    related: ['anxiety', 'thought-diary', 'self-check', 'how-lumi-works'],
    news: ['16', '20']
  },
  'between-sessions': {
    kind: 'topic',
    images: [
      'poshuk_ALL_07_between_sessions',
      'poshuk_L_01_session_over_walk',
      'poshuk_L_02_notes_for_session',
      'poshuk_L_03_week_planner'
    ],
    related: ['thought-diary', 'self-check', 'how-lumi-works', 'anxiety'],
    news: ['32', '16']
  },
  'self-check': {
    kind: 'topic',
    images: ['poshuk_L_03_week_planner', 'osvita_L_04_memory_progress'],
    related: ['how-lumi-works', 'thought-diary', 'anxiety', 'between-sessions'],
    news: ['17', '16']
  },
  'lumi-stories': {
    kind: 'stories',
    images: [],
    related: ['how-lumi-works', 'download', 'thought-diary'],
    news: []
  },
  download: {
    kind: 'download',
    images: ['bez_ALL_07_pocket_friend'],
    related: ['how-lumi-works', 'lumi-stories', 'faq'],
    news: []
  },
  faq: { kind: 'faq', images: [], related: ['how-lumi-works', 'impressum', 'download'], news: [] }
};

export function relatedLumiPath(text) {
  const s = String(text || '').toLowerCase();
  if (/anxiet|panic|тривог|angst|panik|панік/.test(s)) return '/anxiety';
  if (/diary|щоденник|gedanken|кпт|\bcbt\b|rumination|руміна|thought record/.test(s)) return '/thought-diary';
  if (/therap|сесі|session|терап|zwischen den sitzungen/.test(s)) return '/between-sessions';
  if (/burnout|вигоран|überlast|work stress|стрес на робот|робот/.test(s)) return '/burnout';
  return '/how-lumi-works';
}

export const RELATED_LABELS = {
  impressum: 'footer.impressum',
  'how-lumi-works': 'nav.how_lumi_works',
  'thought-diary': 'nav.thought_diary',
  anxiety: 'nav.anxiety',
  burnout: 'nav.burnout',
  'between-sessions': 'nav.between_sessions',
  'self-check': 'nav.self_check',
  'lumi-stories': 'nav.lumi_stories',
  download: 'nav.download',
  faq: 'footer.faq'
};
